var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:(_vm.prefixCls + "-wrapper")},[_c('span',{class:_vm.cls},[_c('input',{class:(_vm.prefixCls + "-input"),attrs:{"type":"checkbox","disabled":_vm.disabled}}),_vm._v(" "),_c('span',{class:(_vm.prefixCls + "-inner")})]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a9bab05","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkbox/checkbox.vue
// module id = null
// module chunks = 